export { default } from "@features/investments/screens/rates-screen";
